import { TableColumn } from '../../models/table-column';
import { TextKeys } from '../../i18n/text-keys';
import { OperationColumnsEnum } from './operation-columns.enum';
import {OperationFilterOptionModel} from '../../models/operation/operation-filter-option.model';

export const getTableColumns = (): TableColumn[] => [
  {
    name: OperationColumnsEnum.Operation,
    position: 0,
    selected: true,
    text: TextKeys.operation.title,
  },
  {
    name: OperationColumnsEnum.Note,
    position: 1,
    selected: true,
    text: TextKeys.operation.note,
  },
  {
    name: OperationColumnsEnum.CostCenterNumber,
    position: 2,
    selected: true,
    text: TextKeys.costCenter.numberShort,
  },
  {
    name: OperationColumnsEnum.CostCenterName,
    position: 3,
    selected: true,
    text: TextKeys.costCenter.title,
  },
];

export const getOperationFilterOptions = (): OperationFilterOptionModel => ({
  operation: {
    name: TextKeys.operation.title,
    selected: false,
  },
  note: {
    name: TextKeys.operation.note,
    selected: false,
  },
  costCenterNumber: {
    name: TextKeys.costCenter.numberShort,
    selected: false,
  },
  costCenterName: {
    name: TextKeys.costCenter.title,
    selected: false,
  },
});
